import blankPage from '@/components/blankPage/index.vue';

export default [
  {
    path: '/talentInspection',
    component: blankPage,
    redirect: '/talentInspection/activities',
    meta: { title: '人才考察' },
    children: [
      {
        path: 'activities',
        name: 'talentInspectionActivities',
        component: () => import('@/views/talentInspection/activity/index.vue'),
        meta: { title: '职级认证考察' }
      },
      {
        path: 'detail/:id',
        name: 'talentInspectionDetail',
        component: () => import('@/views/talentInspection/detail/index.vue'),
        meta: {
          title: route => route.query.activityName || '人才考察详情',
          parentAuth: '/talentInspection/activities'
        },
        props: true
      }
    ]
  }
];
